// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"V1-z","subtitle":"W1-z","wrapper":"X1-z","leftArrow":"Y1-z","rightArrow":"Z1-z"};